function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React, { Fragment } from "react";
import PropTypes from "prop-types";
// Material imports
import withStyles from "@mui/styles/withStyles";
import IconButton from "@mui/material/IconButton";
import Star from "@mui/icons-material/StarRounded";
import { createInitialState } from "@limitless/modern/components/star-ratings/StarRatings";
const StarRatingSystem = ({
  classes,
  onClick,
  rating,
  maxScore,
  disabled,
  hasPreviousScore,
  fontSize = 30,
  compact = false,
  containerClass,
  isMobileDevice = false
}) => {
  const [localRating, setLocalRating] = React.useState(rating);
  const [stars, setStars] = React.useState(createInitialState(maxScore));
  const [aniState, setAniState] = React.useState("none");
  React.useEffect(() => {
    const val = rating || localRating;
    updateStars(val - 1);
  }, []);
  React.useEffect(() => {
    setLocalRating(rating);
    updateStars(rating - 1);
  }, [rating]);
  const updateStars = hoverIndex => {
    const newStars = {};
    Object.keys(stars).map(key => {
      newStars[key] = false;
      if (key <= hoverIndex) {
        newStars[key] = true;
      }
    });
    setStars(newStars);
  };
  const addEvents = key => {
    const updateFunc = () => updateStars(key);
    const changeScoreFunc = () => {
      updateStars(Number(key));
      setLocalRating(Number(key) + 1);
      onClick(Number(key) + 1);
      setAniState("start");
    };
    if (!disabled) {
      if (hasPreviousScore) {
        return {
          onClick: changeScoreFunc
        };
      }
      return {
        onMouseOver: updateFunc,
        onFocus: isMobileDevice ? changeScoreFunc : updateFunc,
        onClick: changeScoreFunc
      };
    }
    return {};
  };
  const handleTransitionEnd = () => {
    setAniState("finish");
  };
  const delay = 50;
  return /*#__PURE__*/React.createElement("div", {
    className: `${classes.starsContainer} ${containerClass}`,
    rating: localRating
  }, /*#__PURE__*/React.createElement(Fragment, null, Object.keys(stars).map((key, index) => {
    const star = stars[key];
    const indexDelay = index * delay;
    let styles = {};
    if (star) {
      switch (aniState) {
        case "start":
          styles.transform = "scale(0.5)";
          styles.transition = "all .1s linear";
          break;
        case "finish":
          styles.transition = `all ${indexDelay}ms ease-in-out`;
          styles.transform = "scale(1.15)";
          break;
        default:
          styles = {};
      }
    }
    return /*#__PURE__*/React.createElement(IconButton, _extends({
      classes: {
        root: compact ? classes.compactIconRoot : classes.iconRoot
      },
      key: key,
      disabled: disabled,
      className: classes.button,
      component: "div"
    }, addEvents(key), {
      style: styles,
      onTransitionEnd: handleTransitionEnd,
      size: "large"
    }), star === true ? /*#__PURE__*/React.createElement(Star, {
      className: classes.star,
      style: {
        fontSize
      },
      onTransitionEnd: handleTransitionEnd
    }) : /*#__PURE__*/React.createElement(Star, {
      key: key,
      className: classes.starBorder,
      style: {
        fontSize
      }
    }));
  })));
};
const styles = ({
  palette
}) => {
  let starColor = "#FFB300";
  let starBorderColor = "#D7D7D7";
  if (palette.star) {
    starColor = palette.star.fill;
    starBorderColor = palette.star.border;
  }
  return {
    starsContainer: {
      display: "flex",
      maxHeight: 56,
      alignItems: "center",
      justifyContent: "space-around"
    },
    star: {
      color: starColor
    },
    starBorder: {
      color: starBorderColor
    },
    button: {
      "&:hover, &.Mui-focusVisible": {
        backgroundColor: "transparent"
      }
    },
    iconRoot: {
      padding: 8
    },
    compactIconRoot: {
      padding: 0
    }
  };
};
export default withStyles(styles)(StarRatingSystem);
StarRatingSystem.propTypes = {
  classes: PropTypes.object.isRequired,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  rating: PropTypes.number.isRequired,
  maxScore: PropTypes.number.isRequired,
  hasPreviousScore: PropTypes.bool.isRequired,
  fontSize: PropTypes.number,
  compact: PropTypes.bool,
  containerClass: PropTypes.string,
  isMobileDevice: PropTypes.bool
};